var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 -4 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.80288754 6.34043826 15.4186507 14.72648904 17.58203125 25.4921875 C18.92007691 37.90936834 17.85729499 48.88109459 10.39453125 59.2421875 C3.58210875 67.3274193 -4.72289951 73.55522767 -15.48876953 74.71533203 C-28.40007937 75.61089799 -39.16843729 74.04490094 -49.3515625 65.46484375 C-57.86959925 57.33325857 -62.42046403 48.68416257 -62.88867188 36.85693359 C-63.04371176 24.34263074 -60.22647828 14.71931927 -51.41796875 5.4921875 C-37.63784493 -7.66275112 -16.31305228 -10.17259803 0 0 Z ",
    fill: "#76E7AD",
    transform: "translate(70.41796875,13.5078125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.78496138 1.51398455 4.0072198 2.0144396 6 6 C-2.91 14.91 -11.82 23.82 -21 33 C-24.45259693 31.27370154 -26.07238601 30.16774527 -28.671875 27.5234375 C-29.33574219 26.853125 -29.99960937 26.1828125 -30.68359375 25.4921875 C-31.36550781 24.79351562 -32.04742187 24.09484375 -32.75 23.375 C-33.44738281 22.66859375 -34.14476562 21.9621875 -34.86328125 21.234375 C-36.58012488 19.49401297 -38.29211832 17.74915019 -40 16 C-38.48601545 12.21503862 -37.9855604 11.9927802 -34 10 C-30.37 13.63 -26.74 17.26 -23 21 C-19.2345098 19.1172549 -17.35356586 17.58807351 -14.453125 14.6484375 C-13.60878906 13.79765625 -12.76445313 12.946875 -11.89453125 12.0703125 C-10.58548828 10.73613281 -10.58548828 10.73613281 -9.25 9.375 C-7.91775391 8.02921875 -7.91775391 8.02921875 -6.55859375 6.65625 C-4.36783031 4.44192996 -2.18187237 2.22307565 0 0 Z ",
    fill: "#145E37",
    transform: "translate(66,33)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.8c9c4ffa0ed7e924ae7c47f336941704.svg";
export { ForwardRef as ReactComponent };